import styles from './NewJourney.module.css'

const NewJourney = () => {
  return (  
    <main className={styles.container}>
      <h1>This is the NewJourney page</h1>
    </main>
  )
}

export default NewJourney
